import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=dd0b1368&class=product"
import script from "./product-item.vue?vue&type=script&lang=js"
export * from "./product-item.vue?vue&type=script&lang=js"
import style0 from "./product-item.vue?vue&type=style&index=0&id=dd0b1368&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports